import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

import { MyState } from '../server';
import rootReducer from './reducers';

export default function configureStore(preloadedState: MyState) {
	const composeEnhancers = composeWithDevTools({
		trace: true,
	});
	return createStore(
		rootReducer as any,
		preloadedState,
		composeEnhancers(
			applyMiddleware(
				thunkMiddleware,
			),
		),
	);
}
